import React, { ReactNode, ErrorInfo } from "react";

interface ErrorBoundaryProps {
  children: ReactNode;
}
interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: unknown): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, errorInfo: ErrorInfo) {
    // Log error to a monitoring service if needed
    console.error("ErrorBoundary caught an error", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center min-h-[300px] px-6 bg-red-50 text-center rounded-lg border border-red-200 shadow">
          <h2 className="text-xl font-bold text-red-900 mb-2">Impact section could not load.</h2>
          <p className="text-red-700 mb-3">
            Sorry, something went wrong loading our impact data. Please refresh, or contact support if this keeps happening.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
